import { Injectable } from "@angular/core";
import { BaseAddress, NullableAddress, NullableAddresses, NullableUser, BaseUser } from "@models/user.model";

@Injectable({
    providedIn: "root",
})
export class CheckoutService {
    constructor() {}

    public setUserInLocalStorage(user: BaseUser): void {
        localStorage.setItem("user", JSON.stringify(user));
    }

    public setAddressInLocalStorage(address: BaseAddress): void {
        localStorage.setItem("address", JSON.stringify(address));
    }

    public getAddressFromLocalStorage(): NullableAddress {
        let storedAddress = localStorage.getItem("address");
        if (!storedAddress) {
            return null;
        }
        return JSON.parse(storedAddress);
    }

    public getAddressesFromLocalStorage(): NullableAddresses {
        let storedAddresses = localStorage.getItem("address");
        if (!storedAddresses) {
            return [];
        }
        return JSON.parse(storedAddresses);
    }

    public getCurrentUserFromLocalStorage(): NullableUser {
        let storedUser = localStorage.getItem("user");
        if (!storedUser) {
            return null;
        }
        return JSON.parse(storedUser!);
    }
}
